import cssVars from 'css-vars-ponyfill'
const state = {
  otherColor: '#409EFF',
  witTheme: {
    $witPrimary: '#409EFF',
    $witOpacity1: '#53a8ff',
    $witOpacity2: '#66b1ff',
    $witOpacity3: '#79bbff',
    $witOpacity4: '#8cc5ff',
    $witOpacity5: '#a0cfff',
    $witOpacity6: '#b3d8ff',
    $witOpacity7: '#c6e2ff',
    $witOpacity8: '#d9ecff',
    $witOpacity9: '#ecf5ff'
  }
}

const mutations = {
  /**
   * 设置其他颜色
   * @param {*} state
   * @param {*} color
   */
  SET_OTHER: (state, color) => {
    state.otherColor = color
  },
  /**
   * 设置主题色
   * @param {*} state
   * @param {*} color
   */
  SET_THEME: (state, color) => {
    // 定义变量 color 对象
    const colorArr = {
      $witPrimary: `#${color[0]}`,
      $witOpacity1: color[2],
      $witOpacity2: color[3],
      $witOpacity3: color[4],
      $witOpacity4: color[5],
      $witOpacity5: color[6],
      $witOpacity6: color[7],
      $witOpacity7: color[8],
      $witOpacity8: color[9],
      $witOpacity9: color[10]
    }
    state.witTheme = colorArr
    // console.log('主题色2：', colorArr)
    document.getElementsByTagName('body')[0].style.setProperty('--themeColor', `#${color[0]}`)
    document.getElementsByTagName('body')[0].style.setProperty('--themeColoropacity1', color[2])
    document.getElementsByTagName('body')[0].style.setProperty('--themeColoropacity2', color[3])
    document.getElementsByTagName('body')[0].style.setProperty('--themeColoropacity3', color[4])
    document.getElementsByTagName('body')[0].style.setProperty('--themeColoropacity4', color[5])
    document.getElementsByTagName('body')[0].style.setProperty('--themeColoropacity5', color[6])
    document.getElementsByTagName('body')[0].style.setProperty('--themeColoropacity6', color[7])
    document.getElementsByTagName('body')[0].style.setProperty('--themeColoropacity7', color[8])
    document.getElementsByTagName('body')[0].style.setProperty('--themeColoropacity8', color[9])
    document.getElementsByTagName('body')[0].style.setProperty('--themeColoropacity9', color[10])
    localStorage.setItem('COLOR_WitTHEME', color)
    // 兼容ie
    const allDefaultColor = {
      '--themeColor': `#${color[0]}`,
      '--themeColoropacity1': color[2],
      '--themeColoropacity2': color[3],
      '--themeColoropacity3': color[4],
      '--themeColoropacity4': color[5],
      '--themeColoropacity5': color[6],
      '--themeColoropacity6': color[7],
      '--themeColoropacity7': color[8],
      '--themeColoropacity8': color[9],
      '--themeColoropacity9': color[10]
    }

    cssVars({
      watch: true,
      // variables 自定义属性名/值对的集合
      variables: allDefaultColor,
      // 当添加，删除或修改其<link>或<style>元素的禁用或href属性时，ponyfill将自行调用
      onlyLegacy: false // false 默认将css变量编译为浏览器识别的css样式 true 当浏览器不支持css变量的时候将css变量编译为识别的css
    })
  }
}

const actions = {
  setThemeColor({ commit, state }, color) {
    // console.log('主题色：', color)
    commit('SET_THEME', color)
    commit('SET_OTHER', color[2])
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
